import {NgModule} from '@angular/core';
import {FileManagerModule} from './file-manager/file-manager.module';
import {FootprintModule} from './footprint/footprint.module';
import {NotificationsModule} from './notifications/notifications.module';
import {SharedModule} from '@shared/shared.module';
import {ProjectsModule} from './projects/projects.module';
import {WorkflowModule} from './workflow/workflow.module';
import {TaskManagerModule} from './task-manager/task-manager.module';
import {InboxModule} from './inbox/inbox.module';
import {DataSurveyModule} from './data-survey/data-survey.module';
import {NgxPrintModule} from 'ngx-print';
import {OrbitaxDac6ReporterModule} from './dac6-reporter/orbitax-dac6-reporter.module';
import {DynamicHTMLModule} from '@shared/components/dynamic-html/dynamic-html.module';
import {NewsletterViewerComponent} from '@shared/components/document-viewer/newsletter-viewer/newsletter-viewer.component';
import {FirmModule} from './firm/firm.module';
import {OrbitaxTreatyModule} from './treaty/orbitax-treaty.module';
import {FxRateModule} from './fx-rate/fx-rate.module';
import {OrbitaxTaxSitesModule} from './tax-sites/orbitax-tax-sites.module';
import {ItrcePlannerModule} from './itrce-planner/itrce-planner.module';
import {OrbitaxExcelMemoModule} from './excel-memo/orbitax-excel-memo.module';
import {TaxFormsModule} from './tax-forms/tax-forms.module';
import {TranslationModule} from './translation/translation.module';
import {DdtFilingManagerModule} from '@features/due-date-tracker/ddt-filing-manager.module';
import {SpreadsheetModule} from '@features/spreadsheet/spreadsheet.module';
import {AuditTrackerModule} from '@features/audit-tracker/audit-tracker.module';
import {PresetCountriesModule} from '@features/preset-countries/preset-countries.module';
import {NewsletterModule} from '@features/newsletter/newsletter.module';
import {OicModule} from '@features/oic/oic.module';
import {GemsModule} from '@features/gems/gems.module';
import {DataMappingModule} from '@features/data-mapping/data-mapping.module';
import {ExpertServicesModule} from './expert-services/expert-services.module';
import {TransactionTrackerModule} from '@features/transaction-tracker/transaction-tracker.module';
import {GlobalTaxCalculatorModule} from '@features/global-tax-calculator/global-tax-calculator.module';
import {OrbitaxConnectModule} from '@features/orbitax-connect/orbitax-connect.module';
import {RatesFootnoteViewerComponent} from '@shared/components/document-viewer/rates-footnote-viewer/rates-footnote-viewer.component';
import {PublisherModule} from '@features/publisher/publisher.module';
import {CrossMarketingNavigationComponent} from '@shared/components/document-viewer/cross-marketing-navigation/cross-marketing-navigation.component';
import {AccountSettingsModule} from "@features/account-settings/account-settings.module";
import {SharedPipesModule} from '@shared/shared-pipes.module';
import {XatbotModule} from "@features/xatbot/xatbot.module";
import {PlatformManagementService} from "@shared/services/platform-management.service";
import {ItpAppService} from "@shared/services/itp-app.service";
import {XatBotAppService} from "@features/xatbot/services/xat-bot-app.service";
import {RootDynamicComponentHelper} from "@shared/helpers/root-dynamic-component-helper";
import {AdminpanelAppService} from "@features/admin-panel/services/adminpanel-app.service";
import {SupportAppService} from '@features/support/services/support-app.service';
import {ContactsModule} from '@features/contacts/contacts.module';
import {WorkspaceModule} from '@features/workspace/workspace.module';
import {WorkspaceAppService} from '@shared/services/workspace-app.service';
import {MarketPlaceModule} from "@features/market-place/market-place.module";
import {PlatformModule} from '@features/platform/platform.module';
import {FieldSchemaModule} from '@features/field-schema/field-schema.module';
import { IntelliCanvasModule } from './intellicanvas/intellicanvas.module';
import {Pillar2ComplianceModule} from '@features/pillar2-compliance/pillar2-compliance.module';


@NgModule({
  imports:
    [
      SharedModule,
      XatbotModule,
      PlatformModule,
      AccountSettingsModule,
      ProjectsModule,
      WorkflowModule,
      TaskManagerModule,
      FileManagerModule,
      ExpertServicesModule,
      TransactionTrackerModule,
      NotificationsModule,
      FootprintModule,
      DataSurveyModule,
      NgxPrintModule,
      OrbitaxDac6ReporterModule,
      OrbitaxTreatyModule,
      OrbitaxExcelMemoModule,
      FxRateModule,
      OrbitaxExcelMemoModule,
      TaxFormsModule,
      TranslationModule,
      // DdtFilingManagerModule,
      AuditTrackerModule,
      PresetCountriesModule,
      NewsletterModule,
      OicModule,
      GemsModule,
      GlobalTaxCalculatorModule,
      OrbitaxConnectModule,
      PublisherModule,
      SharedPipesModule,
      ContactsModule,
      Pillar2ComplianceModule,
      IntelliCanvasModule,
      // DynamicHTML
      DynamicHTMLModule.forRoot({
        components: [
          {component: NewsletterViewerComponent, selector: 'particle-newsletter-viewer'},
          {component: RatesFootnoteViewerComponent, selector: 'app-rates-footnote-viewer'},
          {component: CrossMarketingNavigationComponent, selector: 'app-cross-marketing-navigation'}
        ]
      })
    ],
  declarations: [
  ],
  exports: [
    SharedModule,
    ProjectsModule,
    PlatformModule,
    WorkflowModule,
    TaskManagerModule,
    FileManagerModule,
    ExpertServicesModule,
    TransactionTrackerModule,
    NotificationsModule,
    FootprintModule,
    InboxModule,
    FirmModule,
    DataSurveyModule,
    OrbitaxDac6ReporterModule,
    OrbitaxTreatyModule,
    FxRateModule,
    OrbitaxTaxSitesModule,
    ItrcePlannerModule,
    OrbitaxExcelMemoModule,
    TaxFormsModule,
    TranslationModule,
    // DdtFilingManagerModule,
    SpreadsheetModule,
    AuditTrackerModule,
    OicModule,
    PresetCountriesModule,
    NewsletterModule,
    GemsModule,
    DataMappingModule,
    GlobalTaxCalculatorModule,
    OrbitaxConnectModule,
    PublisherModule,
    ContactsModule,
    WorkspaceModule,
    FieldSchemaModule,
    IntelliCanvasModule
  ],
  providers: []
})
export class ParticleModule {
  constructor(private itpAppService: ItpAppService,
              private xatBotAppService: XatBotAppService,
              private workspaceAppService: WorkspaceAppService,
              private adminPanelAppService: AdminpanelAppService,
              private supportAppService: SupportAppService
  ) {
    RootDynamicComponentHelper.register('ItpAppService', itpAppService);
    RootDynamicComponentHelper.register('XatBotAppService', xatBotAppService);
    RootDynamicComponentHelper.register('AdminpanelAppService', adminPanelAppService);
    RootDynamicComponentHelper.register('SupportAppService', supportAppService);
    RootDynamicComponentHelper.register('WorkspaceAppService', workspaceAppService);
  }
}

